import type { TTimestamp } from '@/types';

import dayjs from 'dayjs';

import { useSettingsStore } from '@/store/useSettingsStore';

export const useDateFormatter = () => {
  const settings = useSettingsStore((s) => s.settings);

  const normalizeTimestamp = (value: TTimestamp) => {
    if (value instanceof Date) return value;
    const num = Number(value);
    return num.toString().length === 10 ? num * 1000 : num;
  };

  const convertDateFormat = (format: string) =>
    format
      .replace(/yyyy/gi, 'YYYY')
      .replace(/mm/gi, 'MM')
      .replace(/dd/gi, 'DD')
      .replace(/-/g, '/');

  return {
    formatDate: (v: TTimestamp) =>
      dayjs(normalizeTimestamp(v))
        .locale(settings.language)
        .format(convertDateFormat(settings.dateFormat)),

    formatDateTime: (v: TTimestamp) =>
      dayjs(normalizeTimestamp(v))
        .locale(settings.language)
        .format(`${convertDateFormat(settings.dateFormat)} HH:mm`),
  };
};
